module.exports = __webpack_public_path__ + "static/img/new-exam-choose-picture2.706f6e1a.png";